import { render, staticRenderFns } from "./leaveWord.vue?vue&type=template&id=550abb94&scoped=true&"
import script from "./leaveWord.vue?vue&type=script&lang=js&"
export * from "./leaveWord.vue?vue&type=script&lang=js&"
import style0 from "./leaveWord.vue?vue&type=style&index=0&id=550abb94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550abb94",
  null
  
)

export default component.exports